import { Component, Input, OnInit } from '@angular/core';
import { ReportTerminals, emptyFields, UsersType, TransactionAccountTypes, gstColumnName, ReportTerminal } from '../utilities/common-file';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AuthService } from '../auth/auth.service';
import { countries } from '../utilities/countries';
import { DownloadService } from '../reports/download-service';
import { CommonService } from '../utilities/common-service';
import { Messages } from '../utilities/message';
import { NzTableData } from '../utilities/nz-table.adapter';
import { MerchantSearch } from '../models/merchant';
import { MerchantTransactionSearch } from '../models/merchant-transactions';
import { TransactionService } from '../transactions/transactions.service';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

@Component({
  selector: 'app-view-settled-transactions',
  templateUrl: './view-settled-transactions.component.html',
})
export class ViewSettledTransactionsComponent implements OnInit {
    @Input() selectedTransaction: any;
    @Input() reportType: any;
    showDownload: string;
    loading = false;
    reportTerminal=ReportTerminal;
    emptyField = emptyFields;
    countries = countries;
    transactionsList = [];
    downloadTransactionsList = [];
    userRoles = UsersType;
    totalCommission=0;
    totalGST =0;
    grandTotal=0; 
    currencySymbol='';  
    gst:any = localStorage.getItem('gst');
    hst:any = localStorage.getItem('hst');
    gstColumnName = gstColumnName;
    columnName :any;
    private tableData: NzTableData<MerchantTransactionSearch, any> = new NzTableData<MerchantTransactionSearch, any>
    (new MerchantTransactionSearch(), 'name');

    constructor(private authService: AuthService, private transactionService: TransactionService,
                private notification: NzNotificationService, private drawerRef: NzDrawerRef, private downloadService: DownloadService,
                private commonService: CommonService) {
              }
  ngOnInit() {
    this.hst = (this.hst === "true");
    this.gst = (this.gst === "true");
    if(this.gst && this.hst){
      this.columnName = this.gstColumnName.hst;
      }
      if(this.gst && !this.hst){
      this.columnName = this.gstColumnName.gst;
      }
    if (this.selectedTransaction && this.selectedTransaction.id) {
      // this.tableData.search.id = this.selectedTransaction.id;

      // To show Total Amount, Transfer, Bank and Net amount in Download Excel

      this.downloadService.setSettlementTransactionDetails(this.selectedTransaction);
      this.getReport();
    }
    }

  // Get List with Page Limit
  getReport(startFromPageOne: boolean = true): void {

    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    this.tableData.search.settlementDocId = this.selectedTransaction.id;
    this.tableData.search.locationId = this.selectedTransaction.locationId;
    this.tableData.search.accountType = [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment,TransactionAccountTypes.refund,TransactionAccountTypes['MONTHLY-TRANSFER-FEE']];
    this.transactionService.getMerchantTransactionListView(this.tableData).subscribe((response: any) => {
      this.currencySymbol = this.commonService.getCurrency(this.selectedTransaction.currency);
            this.loading = false;
            this.tableData.total = response.data.total;
            this.tableData.data = response.data.transactions;
            this.showDownload = Messages.downloadReport;
      }, (err) => {
        this.loading = false;
        this.showDownload = '';
      });
}

// For Page Index change
onIndexChange(event) {
  this.tableData.pageIndex = event;
  this.getReport(false);
}
// Get Transaction type
getTransactionType(mode) {
  return this.commonService.getTransactionAccountType(mode);
}
// Get Tag color for Transaction type
getColorForTransactionType(mode) {
  return this.commonService.getColorForTransactionAccountType(mode);
}

// Get currency symbol for amount
getCurrency(currency) {
  return this.commonService.getCurrency(currency);
}
// For Download Settled Transactions in Excel
downloadReport()  {
  this.notification.info('Download Processing', 'Please Wait', {
    nzKey: 'key'
  });
  const value = {
    startDate: this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '',
    endDate: this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '',
    transactionStatus: this.tableData.search.transactionStatus,
    transactionType: this.tableData.search.transactionType,
    settlementStatus: this.tableData.search.settledStatus,
    isSettled: this.tableData.search.isSettled,
    mobileNo: this.tableData.search.type === 'mobile_no' ? this.tableData.search.number  : '',
    accountNo: this.tableData.search.type === 'account_no' ? this.tableData.search.number  : '',
    // tslint:disable-next-line: radix
    id: this.tableData.search.id ? parseInt(this.tableData.search.id) : '',
    name: this.tableData.search.name,
    merchantId: parseInt(this.authService.getMerchantId()),
    locationId: this.tableData.search.locationId ? this.tableData.search.locationId : '',
    accountTypeIn: this.tableData.search.accountType ? this.tableData.search.accountType :
    [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes['MONTHLY-TRANSFER-FEE'],
    TransactionAccountTypes.refund],
    settlementDocId : this.tableData.search.settlementDocId ? this.tableData.search.settlementDocId : '',
  };
     // For Footer 
     var gridFooter;
     var footerData;
     if(this.gst){
      gridFooter = ['Settlement No','Total Settlement Amount','Total Transaction Fee','Total '+this.columnName,'Total FlexM Fee','Total Commission','Total GST','Grand Commission Total','Total Bank Fee','Net Amount Transferred'];
      footerData=[
      this.selectedTransaction.id,this.currencySymbol+this.selectedTransaction.amount,this.currencySymbol+this.selectedTransaction.transactionFee,  this.currencySymbol+this.selectedTransaction.flexmGst,
      this.currencySymbol+this.selectedTransaction.totalFlexmFee,this.currencySymbol+this.totalCommission,this.currencySymbol+this.totalGST,this.currencySymbol+this.grandTotal,this.currencySymbol+this.selectedTransaction.bankFee,this.currencySymbol+this.selectedTransaction.netAmount];
     }else{
      gridFooter = ['Settlement No','Total Settlement Amount','Total Transaction Fee','Total Commission','Total GST','Grand Commission Total','Total Bank Fee','Net Amount Transferred'];
      footerData=[
      this.selectedTransaction.id,this.currencySymbol+this.selectedTransaction.amount,this.currencySymbol+this.selectedTransaction.transactionFee,this.currencySymbol+this.totalCommission,this.currencySymbol+this.totalGST,this.currencySymbol+this.grandTotal,this.currencySymbol+this.selectedTransaction.bankFee,this.currencySymbol+this.selectedTransaction.netAmount];
     }
  this.transactionService.downloadMerchantTransactionReportNew(value).subscribe((response: any) => {
    this.downloadTransactionsList = response.data.transactions;
    if (this.downloadTransactionsList.length > 0) {
        // tslint:disable-next-line: max-line-length
        const headers = ['Transaction ID', 'User Name', 'Transaction Amount', 'Transaction Fee',this.columnName,'Total Flexm Fee','Commission','GST','Total Commission','Bank Fee', 'Net Amount Transferred', 'Transaction Type', 'Narration', 'Created Date'];
        // tslint:disable-next-line: max-line-length
        this.downloadService.onDownloadExcel(headers, ReportTerminals.settledTransactions, '', '', this.downloadTransactionsList, ReportTerminals.settledTransactions,
        ReportTerminals.settledTransactions, '', '',gridFooter,footerData);
      } else {
        this.notification.error('No Details Found', '', {
          nzKey : 'key'
        });
      }
});
}
downloadExcelFromBuffer(){
  // if (this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) {
    this.notification.info('Download Processing', 'Please Wait', {
      nzKey : 'key'
    });
    const value = {
      startDate: this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '',
      endDate: this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '',
      transactionStatus: this.tableData.search.transactionStatus,
      transactionType: this.tableData.search.transactionType,
      settlementStatus: this.tableData.search.settledStatus,
      isSettled: this.tableData.search.isSettled,
      mobileNo: this.tableData.search.type === 'mobile_no' ? this.tableData.search.number  : '',
      accountNo: this.tableData.search.type === 'account_no' ? this.tableData.search.number  : '',
      // tslint:disable-next-line: radix
      id: this.tableData.search.id ? parseInt(this.tableData.search.id) : '',
      name: this.tableData.search.name,
      merchantId: parseInt(this.authService.getMerchantId()),
      locationId: this.tableData.search.locationId ? this.tableData.search.locationId : '',
      accountTypeIn: this.tableData.search.accountType ? this.tableData.search.accountType :
      [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes['MONTHLY-TRANSFER-FEE'],
      TransactionAccountTypes.refund],
      settlementDocId : this.tableData.search.settlementDocId ? this.tableData.search.settlementDocId : '',
    isBufferData:true,
    reportTerminal:this.reportTerminal.SettlementTransactions
    };
    this.transactionService.downloadMerchantTransactionReportNew(value).subscribe((response: any) => {
       const bufferArray = new Uint8Array(response.data.data.data);
      const blob = new Blob([bufferArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const reader = new FileReader();
      reader.onload = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        const data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
        // Provide an option for the user to download the Excel file
        const blobForDownload = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blobForDownload);
        const a = document.createElement('a');
        a.href = url;
        const fileNameForFile = ReportTerminals.settledTransactions + '_' + moment().format('DDMMYYYYhhmmss') + '.xlsx';
        a.download = fileNameForFile
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.notification.remove('key');
      };
      reader.readAsArrayBuffer(blob);
    });
  // } else {
  //   this.notification.error(Messages.noDateSelected, '', {
  //     nzKey : 'key'
  //   });
  // }
}
// To Close drawwer
close() {
    this.drawerRef.close();
}
}
